import styled from 'styled-components';

export const StyledImpulseupgrade = styled.div`
  display: flex;
  .formatted-currency--impulse {
    margin-left: 5px;
  }
`;

export const StyledImpulseupgradeSPButton = styled.div`
  margin-right: 30px;
`;
